import { MetaFunction, json, type LoaderFunctionArgs } from "@remix-run/node"
import { useLoaderData } from "@remix-run/react"
import { Public } from "~/utils/remix"
import videoDefault from "~/assets/videos/default.webp"
import defaultAvatar from "~/assets/default-avatar.webp"
import { VideoGrid } from "~/components/videos"
import { getImage } from "~/utils/image.server"
import { useState } from "react"
import { InfiniteScroll } from "~/components/pagination"
import { StarVideos, VideoVisibility } from "~/models/videos.server"
import { FindStar } from "~/models/users.server"
import { cleanNulls } from "~/utils/data"

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return [
    { title: `Make Love Not Pornstar ${data.starDisplayName}` },
    { property: "og:title", content: `Make Love Not Pornstar ${data.starDisplayName}` },
    { name: "description", content: `Ready to see what ${data.starDisplayName} is really doing in bed?` },
  ]
}

export const loader = Public(async ({ request, context, params }: LoaderFunctionArgs) => {
  if (!params.username) {
    throw json({ user: null }, { status: 404 })
  }

  const star = await FindStar(context, params.username)
  if (!star) {
    throw json({ user: null }, { status: 404 })
  }

  const url = new URL(request.url)
  let page = url.searchParams.get("page") || "1"

  const videos = await StarVideos(context, star.UserID, parseInt(page))

  return json({
    starID: star.UserID,
    starName: star.UserName,
    starDisplayName: star.DisplayName,
    loggedIn: !!context.user,
    items: videos.map((item) => ({
      VideoID: item.VideoID,
      VideoTitle: item.VideoTitle,
      VideoDescription: item.VideoDescription,
      VideoDuration: item.VideoDuration,
      Slug: item.Slug,
      Status: item.Status,
      Visibility: VideoVisibility(context, star, item),
      MarqueeTags: item.VideoMarqueeTags.map((tag) => ({
        MarqueeTagID: tag.MarqueeTag?.MarqueeTagID,
        Name: tag.MarqueeTag?.Name,
        Slug: tag.MarqueeTag?.Slug,
      })),
      Tags: item.ActualVideoTags.map((tag) => ({
        TagID: tag.Tag?.TagID,
        Name: tag.Tag?.Name,
        Slug: tag.Tag?.Slug,
      })),
      StarID: item.User!.UserID,
      StarName: item.User!.UserName,
      StarDisplayName: item.User!.DisplayName,
      StarAvatar: getImage(item.User!.Avatar, defaultAvatar),
      Stills: JSON.parse(cleanNulls(item.Stills, "[]")).map((still: any) =>
        getImage(JSON.stringify(still), videoDefault)
      ),
      BlurredStill: item.BlurredStill || videoDefault,
      Content: item.Content,
      PublishedAt: item.PublishedAt,
    })),
  })
})

export default function Component() {
  const data = useLoaderData<typeof loader>()
  const [items, setItems] = useState(data.items)

  return (
    <div className="mt-8 mx-16">
      <InfiniteScroll items={items} setItems={setItems} action={`/makelovenotpornstars/${data.starName}/videos`}>
        <VideoGrid loggedIn={data.loggedIn} videos={items} source={"Star"} sourceID={data.starID} />
      </InfiniteScroll>
    </div>
  )
}
